export function macNameToVersion(name: string) {
  const versionMap = {
    sonoma: '14',
    ventura: '13',
    monterey: '12',
    bigsur: '11',
    catalina: '10.15',
    mojave: '10.14',
    highsierra: '10.13',
    sierra: '10.12',
  };

  return (versionMap[name.toLowerCase().replaceAll(' ', '')] ?? name) as string;
}

export function macVersionToName(version: string) {
  const nameMap = {
    14: 'Sonoma',
    13: 'Ventura',
    12: 'Monterey',
    11: 'Big Sur',
    10.15: 'Catalina',
    10.14: 'Mojave',
    10.13: 'High Sierra',
    10.12: 'Sierra',
  };

  return (nameMap[version] ?? version) as string;
}
